import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { gql } from "../../utils/gqlClient";
import { wrapQuery } from "../../utils/wrapQuery";
import { getClientId } from "../../utils/config";
export { sendEmail, doMfa, getMfaToken };
var getEmailCodeQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetEmailCode($token: String!, $client: String!) {\n    mfaEmailCode(mfaToken: $token, clientId: $client)\n  }\n"])));
var performMfaQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query PerformMfa(\n    $mfaToken: String!\n    $oobCode: String!\n    $mfaCode: String!\n    $deviceId: String\n    $client: String!\n  ) {\n    mfaTokens(\n      mfaToken: $mfaToken\n      oobCode: $oobCode\n      mfaCode: $mfaCode\n      deviceId: $deviceId\n      clientId: $client\n    ) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n    }\n  }\n"])));
var triggerMfaQuery = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query GetMfaToken($client: String!) {\n    mfaToken(clientId: $client)\n  }\n"])));
async function sendEmail(token) {
  var data = await wrapQuery('sendEmail', getEmailCodeQuery, {
    token: token,
    client: getClientId()
  });
  return data.mfaEmailCode;
}
async function doMfa(mfaToken, oobCode, mfaCode, deviceId) {
  var data = await wrapQuery('doMfa', performMfaQuery, {
    mfaToken: mfaToken,
    oobCode: oobCode,
    mfaCode: mfaCode,
    client: getClientId(),
    deviceId: deviceId
  });
  return data.mfaTokens.tokens;
}
async function getMfaToken(clientId) {
  var data = await wrapQuery('getMfaToken', triggerMfaQuery, {
    client: clientId || getClientId()
  });
  return data.mfaToken;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/one-auth-sdk/dist/esm/methods/apis/mfa.js
// module id = 5494
// module chunks = 11